module.exports = __webpack_public_path__ + "img/web_nine_grids_3.fa8933f0.jpg";